/**
 * Private modules
 */
const {
  accountId,
  createQueryComponent,
  objectIds,
  password,
  username,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createAccountSession: {
    properties: {
      body: {
        properties: {
          password,
          username,
        },
        required: [
          'password',
          'username',
        ],
        type: 'object',
      },
    },
    required: ['body'],
    type: 'object',
  },
  deleteAccountSessions: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getAccountSessions: {
    properties: {
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
